import { useEffect } from "react";

export default function HomeAdmin() {
    useEffect(() => {
        document.title = "Administration - Obsèques en France";
    }, []);

    return (
        <>
            <div className="admin-home-page">
                <h1>Administration</h1>
                <p>Vous êtes connecté en tant qu'administrateur.</p>
                <img className="admin-filigrane" src={process.env.REACT_APP_LOCAL_ASSETS_BASE_URL + "img/logo_oef_trans_no_bg.png"} alt="OEF logo" />
            </div>
        </>
    )
}